import * as React from 'react';
import { connect } from 'react-redux';
import * as ReactDOM from 'react-dom';
import { Route, Link, withRouter } from 'react-router-dom';
import { bindActionCreators } from "redux";

class NewsItemSummary extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.state = {showDetail: false};
    }
    render() {
        const { id, title, date, text, caption, img, link, anchor ,isEmpty, ...props } = this.props;
        
        let image;
        if (img && img.length > 0) {
            image = (
                <img src={img} title={title} style={{ width: "100%" }} />
            );
        }
        let styles = `col-12 col-md-4 mt-4 news-item-summary clickable`;
        let openLink = anchor;
        if (!openLink) {
            openLink = id.toString();
        }
        let target = "_self";
        if (isEmpty && link) {
            openLink = link;
            target = "_blank";
        } else {
            openLink = `/News#${openLink}`;
        }
        return (
            <div className={styles}>
                <a href={openLink} target={target}>
                    <div className="news-sub-header brown-bg text-middle" style={{ width: "100%", height: "100%" }}>
                        <div className="mx-4">
                            <div className="text-muted">{date}</div>
                            <div>{title}</div>
                        </div>
                    </div> 
                    {image}
                </a>
            </div>
        )
    }
}

class NewsItemSummaries extends React.Component<any, any> {

    render() {
        if (!this.props.news || this.props.isLoading) {
            return (<div></div>);
        }

        let promotedNewsItems = this.props.news.filter(n => n.promoted && n.enabled);
        if (promotedNewsItems.length == 0) {
            return (<div></div>);
        }

        let newsItems = promotedNewsItems.map((item, index) => { if (index < 3) { 
            return <NewsItemSummary key={"newsItemSummary" + index} {...item}></NewsItemSummary>; 
        } });

        return (
            <section className="full-page news-banner base3-bg">
                <div>
                    <div className="container">
                        <h1 className="mx-auto text-center">NEWS</h1>
                        <div className="row ">
                            {newsItems}
                        </div>
                        <div className="row mt-4 mb-4">
                            <div className="col-12 text-right">
                                <a className="emphasis-link" href="/News">
                                    <u>Read more</u>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        news: state.siteData.siteData.news,
        isLoading: state.siteData.isLoading
    };
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {},
        dispatch
    );
};


const NewsItemSummaryContainer = connect(mapStateToProps, mapDispatchToProps)(
    NewsItemSummaries
);

export default NewsItemSummaryContainer;


// WEBPACK FOOTER //
// ./src/components/News/NewsItemSummary.tsx